import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import RaluiTech from "./pages/RaluiTech";
import ReferralPage from "./pages/ReferralPage";
import NotFound from "./pages/NotFound"; // <--- 1. IMPORTE AQUI

function App() {
  return (
    <Router>
      <Routes>
        {/* Rota Principal (Home) */}
        <Route path="/" element={<RaluiTech />} />
        {/* Rota de Indicação/Referência */}
        <Route path="/referral" element={<ReferralPage />} />
        {/* Rota 404 (QUALQUER outra coisa cai aqui) */}
        <Route path="*" element={<NotFound />} />{" "}
        {/* <--- 2. ADICIONE ESSA LINHA NO FINAL */}
      </Routes>
    </Router>
  );
}

export default App;
